export default __webpack_public_path__ + "static/media/003-formula.47be3417.svg";